import React from 'react';
import { Box } from '@mui/material';

interface SuggestionsProps {
  noonSuggestions: string[];
  eveningSuggestions: string[];
}

export default function SuggestionsCard({ noonSuggestions, eveningSuggestions }: SuggestionsProps) {

  return (
      <Box className='rounded-xl p-6 border transition' sx={{ borderColor: "divider", backgroundColor: "background.paper", color:"text.primary" }}>
      <span className={`text-sm font-semibold block mb-4 `}>Remplaçants disponibles</span>
      <div className='flex gap-6'>
        {/* Midi */}
        <div className='flex-1'>
          <span className={`text-xs font-bold block mb-3 `}>MIDI</span>
          <div className='space-y-2'>
            {noonSuggestions.slice(0, 3).map((s, i) => (
              <div key={i} className={`text-sm truncate transition `}>{s}</div>
            ))}
            {noonSuggestions.length === 0 && (
              <div className={`text-sm italic }`}>Aucun</div>
            )}
          </div>
        </div>

        {/* Divider */}
        <div className={`w-px `}></div>

        {/* Soir */}
        <div className='flex-1'>
          <span className={`text-xs font-bold block mb-3 `}>SOIR</span>
          <div className='space-y-2'>
            {eveningSuggestions.slice(0, 3).map((s, i) => (
              <div key={i} className={`text-sm truncate transition `}>{s}</div>
            ))}
            {eveningSuggestions.length === 0 && (
              <div className={`text-sm italic `}>Aucun</div>
            )}
          </div>
        </div>
      </div>
    </Box>
  );
}
